import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function OptOut() {
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <>
      <Helmet>
        <title>Opt-Out / Unsubscribe - TEJ Solutions Hub</title>
        <meta name="description" content="Opt-out from SMS and email messages sent through TEJ Solutions Hub platform. Multiple unsubscribe options available." />
      </Helmet>

      <div style={{ paddingTop: '100px', background: '#f9fafb', minHeight: '100vh' }}>
        <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', padding: '4rem 2rem', color: 'white', textAlign: 'center' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800' }}>Opt-Out / Unsubscribe</h1>
          <p style={{ fontSize: '1.1rem', opacity: '0.95' }}>Stop Receiving Messages</p>
        </div>

        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '4rem 2rem' }}>
          
          {/* Quick Opt-Out Methods */}
          <div style={{ background: '#d1fae5', padding: '2rem', borderRadius: '12px', marginBottom: '3rem', border: '2px solid #10b981' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#065f46', marginBottom: '1.5rem', textAlign: 'center' }}>
              ⚡ Quick Opt-Out Methods
            </h2>
            
            <div style={{ display: 'grid', gap: '1rem' }}>
              <div style={{ background: 'white', padding: '1.5rem', borderRadius: '8px' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>
                  📱 Text Message Opt-Out
                </h3>
                <p style={{ fontSize: '1rem', color: '#4b5563', lineHeight: '1.6' }}>
                  Reply <strong style={{ color: '#065f46' }}>STOP</strong>, <strong style={{ color: '#065f46' }}>UNSUBSCRIBE</strong>, <strong style={{ color: '#065f46' }}>CANCEL</strong>, <strong style={{ color: '#065f46' }}>END</strong>, or <strong style={{ color: '#065f46' }}>QUIT</strong> to any SMS message
                </p>
              </div>

              <div style={{ background: 'white', padding: '1.5rem', borderRadius: '8px' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>
                  📧 Email Opt-Out
                </h3>
                <p style={{ fontSize: '1rem', color: '#4b5563', lineHeight: '1.6' }}>
                  Click the <strong style={{ color: '#065f46' }}>Unsubscribe</strong> link at the bottom of any email
                </p>
              </div>
            </div>
          </div>

          {/* Web Form Opt-Out */}
          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1rem' }}>
              Web Form Opt-Out
            </h2>
            <p style={{ fontSize: '1rem', color: '#6b7280', marginBottom: '2rem' }}>
              Submit your phone number or email address to opt-out from all messages:
            </p>

            {submitted ? (
              <div style={{ background: '#d1fae5', padding: '2rem', borderRadius: '12px', border: '2px solid #10b981', textAlign: 'center' }}>
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✓</div>
                <h3 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#065f46', marginBottom: '1rem' }}>
                  Opt-Out Request Received
                </h3>
                <p style={{ fontSize: '1rem', color: '#065f46', lineHeight: '1.8', marginBottom: '1rem' }}>
                  Your opt-out request has been processed. You will no longer receive messages at:
                </p>
                <p style={{ fontSize: '1.1rem', fontWeight: '600', color: '#065f46' }}>
                  {phone && `📱 ${phone}`}
                  {phone && email && ' | '}
                  {email && `📧 ${email}`}
                </p>
                <p style={{ fontSize: '0.95rem', color: '#065f46', marginTop: '1rem' }}>
                  Changes may take up to 24 hours to take full effect.
                </p>
                <button
                  onClick={() => {
                    setSubmitted(false);
                    setPhone('');
                    setEmail('');
                  }}
                  style={{
                    marginTop: '1.5rem',
                    padding: '0.75rem 2rem',
                    background: '#7c3aed',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  Submit Another Request
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '1.5rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                    Phone Number (Optional)
                  </label>
                  <input
                    type="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="(555) 123-4567"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '2px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '1rem'
                    }}
                  />
                  <p style={{ fontSize: '0.85rem', color: '#6b7280', marginTop: '0.5rem' }}>
                    Enter the phone number receiving unwanted SMS messages
                  </p>
                </div>

                <div style={{ marginBottom: '1.5rem' }}>
                  <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                    Email Address (Optional)
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    style={{
                      width: '100%',
                      padding: '0.75rem',
                      border: '2px solid #e5e7eb',
                      borderRadius: '8px',
                      fontSize: '1rem'
                    }}
                  />
                  <p style={{ fontSize: '0.85rem', color: '#6b7280', marginTop: '0.5rem' }}>
                    Enter the email address receiving unwanted emails
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={!phone && !email}
                  style={{
                    width: '100%',
                    padding: '1rem',
                    background: (phone || email) ? 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)' : '#d1d5db',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    cursor: (phone || email) ? 'pointer' : 'not-allowed',
                    transition: 'all 0.3s ease'
                  }}
                >
                  {(phone || email) ? 'Submit Opt-Out Request' : 'Enter Phone or Email'}
                </button>
              </form>
            )}
          </div>

          {/* Additional Information */}
          <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '1.5rem' }}>
              What Happens After Opt-Out?
            </h2>
            
            <div style={{ display: 'grid', gap: '1rem' }}>
              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>
                  ⚡ Immediate Processing
                </h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  Your opt-out request is processed immediately upon receipt
                </p>
              </div>

              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>
                  ⏰ 24-Hour Window
                </h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  Changes may take up to 24 hours to take full effect across all systems
                </p>
              </div>

              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>
                  🔒 Permanent Record
                </h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  Your opt-out preference is maintained permanently to honor your choice
                </p>
              </div>

              <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
                <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem' }}>
                  📋 Confirmation
                </h3>
                <p style={{ fontSize: '0.95rem', color: '#6b7280', lineHeight: '1.6' }}>
                  You may receive a final confirmation message acknowledging your opt-out
                </p>
              </div>
            </div>
          </div>

          {/* Contact Support */}
          <div style={{ background: '#fef3c7', padding: '2rem', borderRadius: '12px', border: '2px solid #fbbf24', marginBottom: '2rem' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#92400e', marginBottom: '1rem' }}>
              Need Help?
            </h3>
            <p style={{ fontSize: '1rem', color: '#78350f', lineHeight: '1.8', marginBottom: '1rem' }}>
              If you continue to receive messages after opting out, or have questions:
            </p>
            <p style={{ fontSize: '1rem', color: '#78350f', lineHeight: '1.8', marginBottom: '0' }}>
              <strong>Email:</strong> contact@tejsolutionshub.com<br />
              <strong>Address:</strong> 4273 Savannah Trce, Atlanta, GA 30349<br />
              <strong>Response Time:</strong> Within 24 hours
            </p>
          </div>

          {/* Links */}
          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <Link to="/privacy-policy" style={{
              display: 'inline-block',
              background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              marginRight: '1rem'
            }}>
              Privacy Policy
            </Link>
            <Link to="/sms-compliance-consent" style={{
              display: 'inline-block',
              background: 'white',
              color: '#7c3aed',
              padding: '1rem 2rem',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
              border: '2px solid #7c3aed'
            }}>
              Compliance Policy
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
